<template>
  <div>
    <NavBarTop v-if="this.$store.state.auth" />
    <NavBarLeft v-if="this.$store.state.auth" />
    <div class="text-xs sidebar-mini-xs" :class="darkMode ? 'dark-mode' : ''" :style="!this.$store.state.auth ? 'background: transparent; min-height: 100vh;' : ''">
      <transition name="fade-slide-rigth" mode="out-in">
        <router-view />
      </transition>
    </div>
    <ContentWrapper v-if="this.$store.state.auth" />
    <div id="sos_color"></div>
  </div>
</template>
<script>
import NavBarTop from "./components/layout/NavBarTop";
import NavBarLeft from "./components/layout/NavBarLeft";
import ContentWrapper from "./components/layout/ContentWrapper";

export default {
  components: {
    NavBarTop,
    NavBarLeft,
    ContentWrapper,
  },

  data() {
    return {
      darkMode: false,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
      empresa: null,
      userLoaded: false,
    };
  },

  computed: {
    empresaData() {
      const user = this.$store.getters.getUser;
      return user && user.empresa ? user.empresa : null;
    }
  },

  watch: {
    '$store.getters.getUser'(newUser) {
      if (newUser && newUser.empresa) {
        this.empresa = newUser.empresa;
        // Aplicar colores de la empresa cuando el usuario cambie
        this.$nextTick(() => {
          this.getColors();
        });
      } else {
        this.empresa = null;
      }
    }
  },

  created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  },

  beforeCreate() {
    this.$Progress.finish();
  },

  async created() {
    // Solo cargar datos del usuario si hay una sesión válida
    if (this.hasValidSession()) {
      try {
        await this.$store.dispatch("getUser");
        // Solo cargar el resto si getUser fue exitoso
        await this.$store.dispatch("getPermissions");
        await this.$store.dispatch("getMenus");
        await this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
        await this.$store.dispatch("setRoutes");
        
        // Marcar que el usuario fue cargado exitosamente
        this.userLoaded = true;
      } catch (error) {
        // Si falla, no cargar el resto
        this.userLoaded = false;
      }
    } else {
      this.userLoaded = false;
    }
  },

  mounted() {
    // getColors necesita acceso al DOM, por eso va en mounted
    // Si el usuario fue cargado, esperar un tick para asegurar que el DOM esté listo
    if (this.userLoaded) {
      this.$nextTick(() => {
        this.getColors();
      });
    } else {
      // Si no hay usuario, cargar colores por defecto
      this.getColors();
    }
  },

  methods: {
    hasValidSession() {
      try {
        // Verificar cookie de sesión de Laravel
        const hasLaravelSession = document.cookie.split(';').some(cookie => 
          cookie.trim().startsWith('laravel_session=') && 
          cookie.trim().length > 'laravel_session='.length
        );
        
        // Verificar estado persistido en Vuex
        const vuexState = localStorage.getItem('vuex');
        let hasStoredAuth = false;
        
        if (vuexState) {
          try {
            const parsed = JSON.parse(vuexState);
            hasStoredAuth = parsed.auth === true && parsed.user !== null;
          } catch (e) {
            hasStoredAuth = false;
          }
        }
        
        return hasLaravelSession || hasStoredAuth;
      } catch (error) {
        return false;
      }
    },

    darkModeChange(dato) {
      this.darkMode = dato;
      this.$store.dispatch("setDarkMode", dato);
    },

    getColors() {
      // Verificar si es el usuario con id = 78 (SOS)
      const user = this.$store.getters.getUser;
      const isSosUser = user && user.id === 78;
      
      // Si es usuario SOS, usar colores de SOS, si no, usar colores de la empresa
      const color1 = isSosUser ? "#00529c" : (this.empresa ? this.empresa.color_1 : "#00529c");
      const color2 = isSosUser ? "#b0c442" : (this.empresa ? this.empresa.color_2 : "#b0c442");
      
      let estiloDinamico = document.getElementById("sos_color");
      estiloDinamico.innerHTML = `
        <style>
          .bg-sos-blue {
            background: ${color1} !important;
          }

          .bg-sos-green {
            background: ${color2} !important;
          }

          .bg-sos-gradient {
            background: ${color1} !important;
            background: -webkit-linear-gradient(to bottom right, ${color2}, ${color1}) !important;
            background: linear-gradient(to bottom right, ${color2}, ${color1}) !important;
          }
        </style>
      `;
    },
  },
};


</script>

<style>
.bg-sos-blue {
  background: #00529c;
}

.bg-sos-green {
  background: #b0c442;
}

.bg-sos-gradient {
  background: #00529c;
  background: -webkit-linear-gradient(to bottom right, #b0c442, #00529c);
  background: linear-gradient(to bottom right, #b0c442, #00529c);
}

.fade-slide-rigth-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-rigth-leave-active {
  transition: all 0.5s ease;
}
.fade-slide-rigth-enter,
.fade-slide-rigth-leave-to {
  transform: translateX(5%);
  opacity: 0;
}

.dark-vselect .vs__search::placeholder,
.dark-vselect .vs__dropdown-toggle,
.dark-vselect .vs__dropdown-menu,
.dark-vselect .vs__dropdown-option {
  background: #343a40;
  border: solid 1px #535b62;
  color: #fff;
  text-transform: lowercase;
  font-variant: small-caps;
}

.dark-vselect .vs__selected-options,
.dark-vselect .vs__selected,
.dark-vselect .vs__search,
.dark-vselect .vs__open {
  color: #fff;
}
.dark-vselect .vs__selected {
  background: #454d55;
}

.dark-vselect .vs__dropdown-option:hover {
  background: rgb(0, 4, 63);
}

.dark-vselect .vs__clear,
.dark-vselect .vs__open-indicator,
.dark-vselect .vs__deselect {
  fill: #fff;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  background: #b7b5b5 !important;
}

.vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100%);
}

.vs__selected {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.error-vselect .vs__dropdown-toggle {
  border: solid thin #dc3545;
}
.ok-vselect .vs__dropdown-toggle {
  border: solid thin #28a745;
}
</style>
